var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNovaMatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1798.282 555.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "119.004 119.004 0 0 0 238.008 79.336 238.008 158.672 238.008 238.008 238.008 238.008 0 119.004 0 119.004 119.004",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 317.343 0 555.351 79.336 555.351 158.672 555.351 238.008 555.351 238.008 317.343 119.004 436.347 0 317.343",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.282,396.679h0c0-43.816-35.52-79.336-79.336-79.336h-158.672v238.008h238.008l-79.336-79.336c43.816,0,79.336-35.52,79.336-79.336Z",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1322.266 317.343 1242.93 317.343 1242.93 396.679 1242.93 396.679 1242.93 476.015 1242.93 476.015 1242.93 555.351 1480.938 555.351 1480.938 476.015 1361.934 476.015 1401.601 436.347 1361.933 396.679 1480.938 396.679 1480.938 317.344 1322.266 317.343 1322.266 317.343",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "667.744 317.343 608.242 317.343 608.242 436.347 667.744 436.347 667.744 555.351 786.748 555.351 786.748 436.347 846.25 436.347 846.25 317.343 786.748 317.343 667.744 317.343",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "985.088 317.343 925.586 317.343 925.586 436.347 985.088 436.347 985.088 555.351 1104.092 555.351 1104.092 436.347 1163.594 436.347 1163.594 317.343 1104.092 317.343 985.088 317.343",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "833.026 238.008 912.362 238.008 991.698 238.008 1071.034 238.008 952.03 0 833.026 238.008",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.344 555.351 396.68 555.351 476.016 555.351 555.352 555.351 436.348 317.343 317.344 555.351",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753.69 0 674.355 0 595.019 0 714.023 238.008 833.026 0 753.69 0",
    fill: "#ff5a40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.347,
    cy: 119.004,
    r: 119.004,
    fill: "#ff5a40",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNovaMatter);
export default __webpack_public_path__ + "static/media/LogoNovaMatter.498460649c333c94885597faf1e99592.svg";
export { ForwardRef as ReactComponent };